import React, { useMemo } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CHART_COLORS } from '../../utils/constants';

// Sums available capacity hours per business unit across a set of target dates
export default function CapacityByBUChart({ capacity, targetDates }) {
  const chartData = useMemo(() => {
    return (capacity || [])
      .map((c, i) => {
        const hours = (targetDates || []).reduce((sum, d) => sum + (c.capacity?.capacityByDay?.[d]?.availableHours || 0), 0);
        const name = c.businessUnit?.name || 'Unknown';
        return { name: name.length > 16 ? name.slice(0, 16) + '…' : name, hours: Math.round(hours * 10) / 10, fill: CHART_COLORS[i % CHART_COLORS.length] };
      })
      .sort((a, b) => b.hours - a.hours);
  }, [capacity, targetDates]);

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 40 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="name" tick={{ fontSize: 11 }} angle={-30} textAnchor="end" interval={0} />
        <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
        <Tooltip formatter={(v) => [`${v} hrs`, 'Open Capacity']} />
        <Bar dataKey="hours" name="Open Capacity (hrs)" radius={[4, 4, 0, 0]}>
          {chartData.map((entry, i) => (
            <Cell key={i} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
